import { IoCContainer, WebCoreIoCKeys } from '../../..';
import { IWebCoreIoCContainer } from '../web-core-ioc-container/web-core-ioc-container.interface';
import { IRandomSentenceGenerator } from './random-sentence-generator.interface';

export class RandomSentenceGeneratorService implements IRandomSentenceGenerator {
    constructor() {
        this.ioc = IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
    }

    private ioc: IWebCoreIoCContainer;

    private nouns = [
        'apple',
        'bread',
        'chair',
        'photo',
        'piano',
        'skirt',
        'thing',
        'skill',
        'movie',
        'steak',
        'truth',
        'depth',
        'union',
        'child',
        'owner',
        'night',
        'river',
        'queen',
        'salad',
        'media',
        'paper',
        'money',
        'cheek',
        'actor',
        'scene',
        'story',
        'world',
        'entry',
        'woman',
        'guest',
        'video',
        'music',
        'power',
        'basis',
        'error',
        'honey',
        'blood',
        'chest',
        'ratio',
        'pizza',
        'stone',
        'heart',
        'buyer',
        'virus',
        'topic',
        'drama',
        'month',
        'beach',
        'globe',
        'house',
    ];

    private verbs = [
        'apply',
        'build',
        'start',
        'plant',
        'swing',
        'blame',
        'drink',
        'learn',
        'waste',
        'reach',
        'clean',
        'throw',
        'fight',
        'think',
        'place',
        'solve',
        'bring',
        'watch',
        'fling',
        'drain',
        'merge',
        'widen',
        'seize',
        'chase',
        'claim',
        'carry',
        'boost',
        'yield',
        'round',
        'check',
        'train',
        'draft',
        'focus',
        'grasp',
        'shift',
        'react',
        'alert',
        'laugh',
        'stage',
        'drift',
        'doubt',
        'trick',
        'visit',
        'cover',
        'shine',
        'break',
        'prove',
        'enter',
        'press',
        'score',
    ];

    private adjectives = [
        'shiny',
        'jolly',
        'dirty',
        'jaded',
        'ready',
        'short',
        'salty',
        'right',
        'silly',
        'faint',
        'sharp',
        'spiky',
        'tasty',
        'furry',
        'basic',
        'bored',
        'bland',
        'flaky',
        'stiff',
        'gusty',
        'windy',
        'zippy',
        'crisp',
        'giant',
        'gross',
        'chilly',
        'drunk',
        'nappy',
        'cheap',
        'broad',
        'quiet',
        'needy',
        'clear',
        'curvy',
        'elite',
        'tired',
        'spicy',
        'bumpy',
        'smooth',
        'glowy',
        'nasty',
        'buzzy',
        'lumpy',
        'shaky',
        'witty',
        'grimy',
        'dusky',
        'lofty',
        'nifty',
        'leafy',
    ];

    private nouns2 = [
        'cabin',
        'cloud',
        'plant',
        'clock',
        'table',
        'shelf',
        'frame',
        'flame',
        'crate',
        'flock',
        'crown',
        'field',
        'track',
        'sword',
        'brush',
        'cable',
        'chalk',
        'drill',
        'fiber',
        'glass',
        'grape',
        'knife',
        'latch',
        'level',
        'liver',
        'lunch',
        'match',
        'meaty',
        'nerve',
        'pouch',
        'ranch',
        'ridge',
        'robin',
        'scale',
        'shack',
        'slope',
        'spine',
        'spoon',
        'stamp',
        'strap',
        'sweat',
        'sweep',
        'sword',
        'swirl',
        'torch',
        'trail',
        'trunk',
        'wrist',
        'wreck',
        'zebra',
    ];

    private verbs2 = [
        'admit',
        'avoid',
        'blink',
        'blend',
        'boast',
        'brush',
        'chant',
        'choke',
        'cling',
        'climb',
        'clink',
        'crawl',
        'creep',
        'dance',
        'delay',
        'dodge',
        'dress',
        'equip',
        'evade',
        'excel',
        'exist',
        'feast',
        'fetch',
        'fixes',
        'grind',
        'haunt',
        'hatch',
        'hurry',
        'kneel',
        'knock',
        'label',
        'march',
        'match',
        'mourn',
        'nudge',
        'obeys',
        'offer',
        'paint',
        'pause',
        'peels',
        'point',
        'prank',
        'punch',
        'quake',
        'raise',
        'roast',
        'shout',
        'skate',
        'slice',
        'trace',
    ];

    public generateSettingName(): string {
        const word1 = this.getRandom(this.nouns);
        const word2 = this.getRandom(this.verbs);
        const word3 = this.getRandom(this.adjectives);
        const word4 = this.getRandom(this.nouns2);
        const word5 = this.getRandom(this.verbs2);

        return word1 + word2 + word3 + word4 + word5;
    }

    private getRandom(list: string[]): string {
        let word = list[Math.floor(Math.random() * list.length)];
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
}
